import { useEffect } from 'react';
import { useLocation, useNavigate } from 'react-router-dom';

export default function LoginParticipanteSenhaPage() {
  const location = useLocation();
  const navigate = useNavigate();

  useEffect(() => {
    const current = new URLSearchParams(location.search || '');
    const safe = new URLSearchParams();
    const turma = (current.get('turma') || '').trim();
    const dest = (current.get('dest') || '').trim().toLowerCase();
    if (turma) safe.set('turma', turma);
    if (dest === 'res' || dest === 'ead') safe.set('dest', dest);
    const search = safe.toString();

    navigate(`/participante/login${search ? `?${search}` : ''}`, {
      replace: true,
      state: { from: location.state?.from || null },
    });
  }, [location.search, location.state, navigate]);

  return null;
}
